// extracted by mini-css-extract-plugin
export var cardIcon = "_9a-5";
export var checkboxCard = "_9a-0";
export var checkboxCardSelected = "_9a-4";
export var disabled = "_9a-2";
export var interactive = "_9a-1";
export var outerBorder = "_9a-3";
export var spacerMedium = "_9a-8";
export var spacerSmall = "_9a-7";
export var spacerXsmall = "_9a-6";